import { InProgressReport, ExportResult } from '../../../models';

export const updateReportResultStatusFromInprogressReports = (
  reportResults: ExportResult[],
  inprogressReport: InProgressReport[] = [],
): ExportResult[] => {
  if (!reportResults) return reportResults;
  const inprogressReportsMap = inprogressReport.reduce(
    (acc, report) => acc.set(report.taskId, report),
    new Map<number, InProgressReport>(),
  );
  return reportResults.map((report) => {
    const inprogressReport = inprogressReportsMap.get(report.taskId);
    if (!inprogressReport) return report;
    report.statusId = inprogressReport.reportStatus;
    inprogressReportsMap.delete(report.taskId);
    return report;
  });
};
